import Modal from '../custom/Modal';
import Close from '../../assets/images/icons/close.svg';
import { useDispatch } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import PrivacyModalCustomization from '../customizations/PrivacyModalCustomization';

const PrivacyModal = () => {
	const dispatch = useDispatch();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.PRIVACY_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal}>
			<div className="modal-actions">
				<div className="modal-actions-close" onClick={handleOnCloseModal}>
					<img className="modal-close" src={Close} alt="Close" />
				</div>
			</div>
			<PrivacyModalCustomization />
		</Modal>
	);
};

export default PrivacyModal;
